export const checkZipCode = (value, country) => {
  if (country.value === '1') {
    return /^\d{5,}$/.test(value);
  } else if (country.value === '38') {
    return /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(value);
  }
  return false;
}